
import { Action } from '@ngrx/store';



export enum SellerActionTypes {
  SELLER = 'SELLER',
  SELLER_SUCCESS  = 'SELLER_SUCCESS',
  SELLER_FAILURE  = 'SELLER_FAILURE',
}

export class Seller implements Action {
  readonly type = SellerActionTypes.SELLER;
  
}
export class SellerSuccess implements Action {
  readonly type = SellerActionTypes.SELLER_SUCCESS;
  constructor(public payload: any) {}
}


export class SellerFailure implements Action {
  readonly type = SellerActionTypes.SELLER_FAILURE;
  constructor(public payload: any) {}
}

export type All =
  | Seller
  | SellerSuccess
  | SellerFailure;